'use client'
import { useState, useEffect } from "react";
import { Share, MoreVertical } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function AddToHomeScreenPrompt() {
  const pathname = usePathname();
  const [showPrompt, setShowPrompt] = useState(false);
  const [deviceType, setDeviceType] = useState<'ios' | 'android' | null>(null);

  useEffect(() => {
    // Check if not in standalone mode (not already installed)
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
    
    if (isStandalone) return; // Already installed as PWA
    
    // Detect device type
    const userAgent = window.navigator.userAgent;
    const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroidDevice = /Android/i.test(userAgent);
    
    if (isIosDevice) {
      setDeviceType('ios');
      setShowPrompt(true);
    } else if (isAndroidDevice) {
      setDeviceType('android');
      setShowPrompt(true);
    }
  }, []);

  // Hide on onboarding page
  if (pathname === '/onboarding' || pathname === '/batch' || pathname === '/swipe') return null;
  
  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 p-4 bg-white shadow-lg shadow-primary rounded-md flex flex-col z-50">
      {/* Main prompt */}
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          {deviceType === 'ios' ? (
            <p className="text-sm font-medium flex items-center gap-1 flex-wrap">
              Install this app: Tap <span className="font-bold flex items-center">
                Share <Share size={16} className="inline text-blue-500 ml-0.5" />
              </span> and then{" "}
              <span className="font-bold">Add to Home Screen</span>.
            </p>
          ) : (
            <p className="text-sm font-medium flex items-center gap-1 flex-wrap">
              Install this app: Tap <span className="font-bold flex items-center">
                Menu <MoreVertical size={16} className="inline text-gray-700 ml-0.5" />
              </span> and then{" "}
              <span className="font-bold">Add to Home Screen</span>.
            </p>
          )}
        </div>
        <button
          className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium ml-3"
          onClick={() => setShowPrompt(false)}
        >
          Dismiss
        </button>
      </div>
      
      {/* Help link */}
      <div className="mt-2 text-center">
        <Link 
          href="/help/install"
          className="text-sm text-blue-600 hover:text-blue-800"
        >
          Need help installing? <span className="underline font-medium">Click here</span>
        </Link>
      </div>
    </div>
  );
}
